import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Api from '../Auth/Api';
import { Modal, Button, Spinner } from 'react-bootstrap';

function PrimeiroLogin() {
    const navigate = useNavigate();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [termoAtual, setTermoAtual] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const token = JSON.parse(localStorage.getItem("user_token"));

    // Buscar termo ativo do banco de dados
    useEffect(() => {
        async function fetchTermoAtual() {
            try {
                const response = await Api.get('api/termo-atual', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setTermoAtual(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Erro ao carregar termo:', error);
                setError('Erro ao carregar o termo de aceite. Por favor, tente novamente.');
                setLoading(false);
            }
        }
        fetchTermoAtual();
    }, [token]);

    const handleAccept = async () => {
        try {
            await Api.post(`api/primeiro-login`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setShowSuccessModal(true);
            localStorage.setItem("primeiro_login", "1");
        } catch (error) {
            console.error('Erro ao enviar os termos de adesão:', error);
        }
    };

    const handleClose = () => {
        setShowSuccessModal(false);
        navigate('/trocar-senha'); // Redireciona para a home
    };

    // Função para construir URL do arquivo
    const getFileUrl = (arquivo) => {
        if (!arquivo) return null;
        // O arquivo pode vir em dois formatos:
        // 1. nome_gerado/nome_original.pdf (formato completo)
        // 2. nome_gerado.pdf (apenas nome gerado com extensão)
        // Precisamos extrair apenas o nome do diretório (sem extensão)
        let diretorio;
        if (arquivo.includes('/')) {
            // Formato: nome_gerado/nome_original.pdf
            diretorio = arquivo.split('/')[0];
        } else {
            // Formato: nome_gerado.pdf - remover extensão
            diretorio = arquivo.replace(/\.pdf$/i, '');
        }
        const base = (process.env.REACT_APP_FILES_URL || '').replace(/\/$/, '');
        return `${base}/${diretorio}`;
    };

    if (loading) {
        return (
            <div className="fade-in w-100">
                <div className="d-flex align-items-center justify-content-center p-5">
                    <Spinner animation="border" variant="primary" />
                </div>
            </div>
        );
    }

    if (error || !termoAtual) {
        return (
            <div className="fade-in w-100">
                <div className="alert alert-danger">
                    {error || 'Nenhum termo de aceite encontrado. Entre em contato com o administrador.'}
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="fade-in w-100">
                <span className="text-primary fs-1">Termo de adesão</span>
                <p className="fs-6">Antes de continuar, você deve ler e aceitar os termos abaixo</p>
                <div className="body rounded bg-white px-3 py-3">
                    <section className="w-100">
                        <div className="d-flex justify-content-center">
                            <iframe 
                                title="primeiro_login" 
                                src={getFileUrl(termoAtual.arquivo)} 
                                style={{ 
                                    border: '0', 
                                    width: '100%', 
                                    height: 'calc(100vh - 350px)'
                                }}
                            />
                        </div>
                        <div className="d-flex justify-content-center mt-3">
                            <button className="btn btn-primary me-3" onClick={handleAccept}>Aceitar</button>
                        </div>
                    </section>
                </div>
            </div>

            <Modal show={showSuccessModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Sucesso</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>Termos aceitos com sucesso!</b> <br/>Antes de acessar a plataforma você precisa definir uma nova senha!</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Definir nova senha
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default PrimeiroLogin;
